import { combineReducers } from "redux";
import authReducer from "../components/auth/store/authReducer";
import accountReducer from "../components/account/store/accountReducer";

import workspaceReducer from "../components/shared/layout/store/workspaceReducer";
import teamReducer from "../components/team/store/teamReducer";
import workspaceUsersReducer from "../components/workspace/users/store/workspaceUsersReducer";
import chatbotReducer from "../components/chatbot/store/chatbotReducer";
import chatbotWidgetReducer from "../widgets/chatbot/content/store/chatbotWidgetReducer";
import mcpPlaygroundReducer from "../components/mcp-platform/store/mcpPlaygroundReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  account: accountReducer,
  team: teamReducer,
  workspace: workspaceReducer,
  workspaceUsers: workspaceUsersReducer,

  chatbot: chatbotReducer,
  chatbotWidget: chatbotWidgetReducer,
  playgrounds: mcpPlaygroundReducer,
});

export default rootReducer;
